/* CASEMANAGEMENT-1592: Cart shipping fee client */
(function () {
  'use strict';

  var FETCH_TIMEOUT_MS = 5000;
  var SELECTOR = '[data-cart-shipping-fee]';

  // 概算表示要素は通知/ドロワーの再描画で作り直されるため、参照を固定せず毎回最新を取得する（CASEMANAGEMENT-1592）
  function getRoots() {
    return document.querySelectorAll(SELECTOR);
  }

  var inflight = null;

  var TAX_RATE = 1.1;

  function withTax(n) {
    return Math.floor(Number(n) * TAX_RATE);
  }

  function fmtYen(n) {
    return '<span class="yen">¥</span>' + Number(n).toLocaleString('ja-JP') + '<span class="tax">(税込)</span>';
  }

  function setText(root, html) {
    var el = root.querySelector('[data-cart-shipping-fee-value]');
    if (el) el.innerHTML = html;
  }

  function showFallback(root) {
    var fallback = root.getAttribute('data-fallback-text') || 'ご注文時に計算';
    setText(root, fallback);
    root.hidden = false;
  }

  function show(root, payload) {
    if (payload.is_free) {
      root.hidden = true;
      return;
    }
    setText(root, fmtYen(withTax(payload.shipping_fee)));
    root.hidden = false;
  }

  function hideAll() {
    getRoots().forEach(function (root) { root.hidden = true; });
  }

  function recalc() {
    var roots = getRoots();
    if (!roots.length) return;

    if (inflight) {
      inflight.controller.abort();
      inflight = null;
    }

    var controller = new AbortController();
    var timedOut = false;
    var timeoutId = setTimeout(function () { timedOut = true; controller.abort(); }, FETCH_TIMEOUT_MS);
    inflight = { controller: controller };

    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || cart.item_count === 0) {
          hideAll();
          return null;
        }
        var endpoint = roots[0].getAttribute('data-endpoint');
        var body = {
          items: (cart.items || []).map(function (it) {
            // __discounted_price_checkout_ext はチェックアウト拡張用の価格上書き値。カート時点では二重割引(final_price×0.9)が入り概算を誤らせるため除外し、Shopify の final_price(正しい割引後単価)を使う（CASEMANAGEMENT-1592）
            var props = {};
            var srcProps = it.properties || {};
            for (var key in srcProps) {
              if (Object.prototype.hasOwnProperty.call(srcProps, key) && key !== '__discounted_price_checkout_ext') {
                props[key] = srcProps[key];
              }
            }
            return {
              sku: it.sku,
              quantity: it.quantity,
              // it.price は自動割引/割引コード非反映の deprecated 値のため割引後 final_price を送る（概算を決済実送料・カート表示と一致させる）
              price: (typeof it.final_price === 'number' ? it.final_price : it.price),
              properties: props,
            };
          }),
        };
        return fetch(endpoint, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(body),
          signal: controller.signal,
        }).then(function (r) {
          if (!r.ok) throw new Error('http_' + r.status);
          var ct = r.headers.get('content-type') || '';
          if (ct.indexOf('application/json') === -1) throw new Error('not_json');
          return r.json();
        });
      })
      .then(function (payload) {
        if (!payload) return;
        // 再描画後の最新要素に反映する
        getRoots().forEach(function (root) { show(root, payload); });
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') {
          // タイムアウト由来の中断のみフォールバック表示（再計算による中断は現表示を維持）
          if (timedOut) getRoots().forEach(function (root) { showFallback(root); });
          return;
        }
        // eslint-disable-next-line no-console
        console.warn('cart-shipping-fee fetch failed:', err);
        getRoots().forEach(function (root) { showFallback(root); });
      })
      .finally(function () {
        clearTimeout(timeoutId);
        inflight = null;
      });
  }

  // 連続トリガーをまとめ、再描画が落ち着いてから再計算する
  var debounceId = null;
  function scheduleRecalc() {
    clearTimeout(debounceId);
    debounceId = setTimeout(recalc, 120);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleRecalc);
  } else {
    scheduleRecalc();
  }

  // 標準のカート更新イベント（product-form など）
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () { scheduleRecalc(); });
  }

  // 追加トリガー（CASEMANAGEMENT-1592）:
  // Yogibo Care(GPO)バンドル等、一部の追加フローはテーマの cartUpdate を publish しない。
  // そのため (a) Cart Ajax API へのリクエスト と (b) 通知/ドロワーの開閉 を検知して再計算する。
  var CART_MUTATION_RE = /\/cart\/(add|change|update|clear)(\.js)?($|\?)/;

  // (a) fetch / XMLHttpRequest のカート変更リクエストを検知（フロー非依存）
  if (window.fetch && !window.fetch.__cartShippingFeeHooked) {
    var origFetch = window.fetch;
    var hookedFetch = function (input) {
      var url = (input && input.url) || input;
      var ret = origFetch.apply(this, arguments);
      if (typeof url === 'string' && CART_MUTATION_RE.test(url) && ret && typeof ret.then === 'function') {
        ret.then(function () { scheduleRecalc(); }, function () {});
      }
      return ret;
    };
    hookedFetch.__cartShippingFeeHooked = true;
    window.fetch = hookedFetch;
  }
  if (window.XMLHttpRequest && !XMLHttpRequest.prototype.__cartShippingFeeHooked) {
    var origOpen = XMLHttpRequest.prototype.open;
    var origSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__cartShippingFeeUrl = url;
      return origOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function () {
      if (typeof this.__cartShippingFeeUrl === 'string' && CART_MUTATION_RE.test(this.__cartShippingFeeUrl)) {
        this.addEventListener('load', function () { scheduleRecalc(); });
      }
      return origSend.apply(this, arguments);
    };
    XMLHttpRequest.prototype.__cartShippingFeeHooked = true;
  }

  // (b) 通知/ドロワーの開閉・class 変化を監視（再描画後の最新要素に再計算するため）。
  //     監視は対象要素自身の属性のみ（subtree なし）＝概算要素内部の書き換えは拾わずループしない。
  if (typeof MutationObserver === 'function') {
    var cartUis = document.querySelectorAll('cart-notification, cart-drawer');
    if (cartUis.length) {
      var observer = new MutationObserver(function () { scheduleRecalc(); });
      cartUis.forEach(function (el) {
        observer.observe(el, { attributes: true, attributeFilter: ['open', 'class', 'aria-hidden'] });
      });
    }
  }

  window.addEventListener('beforeunload', function () {
    if (inflight) inflight.controller.abort();
  });
})();
